import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

const getErrorName = (state) => {
    const error = resolveProp('router.location.pathname', state).match('/error.*/([^/]+)/?$');
    return error ? error[1] : 'generic';
};

export default createSelector(getErrorName, (errorName) => errorName);
